import React, { PureComponent } from 'react';
import styled from 'styled-components';
import UpdatedDate from './UpdatedDate';
import InfoTooltip from './InfoTooltip';

const StyledStatComponent = styled.div`
  position: relative;
  padding: 20px 20px 35px 20px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  grid-column: span 12;
  @media (min-width: 1024px) {
    grid-column: span ${props => props.columns};
  }
  @media print {
    page-break-inside: avoid;
    margin-bottom: 30px;
    display: inline-block;
  }
`;

const StatNumber = styled.div`
  font-size: 40px;
  line-height: 48px;
  font-family: latoregular;
  color: #42515a;
`;

const StatTitle = styled.div`
  grid-column: span 2;
  font-size: 16px;
  line-height: 19px;
  color: #42515a;
`;

class StatComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: null
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.isMissing && props.data !== state.data) {
      return {
        data: JSON.parse(props.data)[0]
      };
    }
    return null;
  }

  render() {
    return (
      <StyledStatComponent columns={this.props.columns}>
        <StatNumber>{this.state.data || this.props.missingText}</StatNumber>
        <StatTitle>
          {this.props.title}
          {this.props.info && (
            <InfoTooltip
              text={this.props.info}
              iconColor={`#a3a5a7`}
              iconWidth={`16px`}
              iconHeight={`16px`}
            />
          )}
        </StatTitle>
        <UpdatedDate>{`letztes Update: ${this.props.lastUpdated}`}</UpdatedDate>
      </StyledStatComponent>
    );
  }
}

export default StatComponent;
